/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
==========================================================================================*/


import { ROLE_ADMIN, ROLE_CERTIFICATION_MANAGER } from '@/constants/roles'

export default [
  {
    url: "/",
    name: "Home",
    slug: "home",
    icon: "HomeIcon",
  },
  {
    url: "/content",
    name: "Content",
    slug: "content",
    icon: "ListIcon",
  },
  {
    url: null,
    header: "Create content",
    icon: "Edit2Icon",
    items: [
      {
        url: "/create/course",
        name: "Course",
        slug: "create-course",
        icon: "BookIcon",
      },
      {
        url: "/create/video",
        name: "Video",
        slug: "create-video",
        icon: "VideoIcon",
      },
      {
        name: "Quiz",
        icon: "CheckSquareIcon",
        submenu: [
          {
            url: "/bulk/quiz-upload",
            name: "Bulk Quiz Upload",
            slug: "bulk-quiz-upload"
          },
          {
            name: "Create a Quiz",
            url: "/create/quiz",
            slug: "create-quiz",
            icon: "CheckSquareIcon",
          },
        ]
      },
      {
        url: "/create/learning-path",
        name: "Learning Path",
        slug: "create-lp",
        icon: "GitCommitIcon",
      },
      {
        url: "/create/lab",
        name: "Lab",
        slug: "create-lab",
        icon: "GithubIcon",
      },
      {
        url: "/create/exercise",
        name: "Exercise",
        slug: "create-exercise",
        icon: "TerminalIcon",
      },
      {
        url: "/create/iframe",
        name: "iFrame",
        slug: "create-iframe",
        icon: "ExternalLinkIcon",
      },
      {
        name: "Collection",
        icon: "ShoppingBagIcon",
        submenu: [
          {
            url: "/create/collection",
            slug: "create-collection",
            name: "Create a Collection",
          },
          {
            url: "/bulk/collection-upload",
            name: "Bulk Collection Upload",
            slug: "bulk-collection-upload"
          },
        ]
      },
      {
        url: "/create/sonar",
        name: "Skill Sonar",
        slug: "create-sonar",
        icon: "RadioIcon",
      },
      {
        url: "/certification",
        name: "Certification",
        slug: "certification",
        icon: "AwardIcon",
        featureFlag: "certificationManagementTool",
        requiredRoles: [ROLE_CERTIFICATION_MANAGER, ROLE_ADMIN],
      },
    ]
  },
  {
    url: null,
    header: "Stats",
    icon: "Edit2Icon",
    items: [
      {
        url: "/reports",
        name: "Reports",
        slug: "reports",
        icon: "DownloadCloudIcon",
      },
      {
        url: "/reviews",
        name: "Reviews",
        slug: "reviews",
        icon: "StarIcon",
      },
      {
        url: "/charts",
        name: "Charts",
        slug: "charts",
        icon: "PieChartIcon",
      },
    ]
  }
]
